import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { data as agreementDataPropTypes } from '../agreementPropTypes.js';
import partnerPropTypes from '../partnerPropTypes.js';
import formatOreToKroner from '../../lib/formatOreToKroner.js';
import DiscountSuggestionDetails from './discountSuggestionDetails.jsx';

class DiscountDetails extends PureComponent {
    constructor() {
        super();
        this.state = {
            expanded: false,
        };
        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand() {
        this.setState({
            expanded: !this.state.expanded,
        });
    }

    renderCollapsed() {
        return (
            <div className="clickable" onClick={this.toggleExpand}>
                <svg className="valign-middle" width="13" height="13">
                    <use xlinkHref="#icon-arrow-right" />
                </svg>
                &nbsp;&nbsp; Se betalingsoversikt
            </div>
        );
    }

    renderDiscount() {
        const { agreement, partner, role, discount, discountFee } = this.props;

        return (
            <div>
                <div className="r-mtm">
                    <DiscountSuggestionDetails
                        agreement={agreement}
                        partner={partner}
                        discount={discount}
                        discountFee={discountFee}
                        role={role}
                    />
                </div>
            </div>
        );
    }

    renderExpanded() {
        const { agreement, discount, role } = this.props;
        const { amount, fee, total, freight } = agreement;
        const isBuyer = role === 'BUYER';

        const sum = isBuyer ? total + fee : total;

        return (
            <div>
                <div className="clickable r-pbm" onClick={this.toggleExpand}>
                    <svg className="valign-middle" width="13" height="13">
                        <use xlinkHref="#icon-arrow-down" />
                    </svg>
                    &nbsp;&nbsp; Lukk betalingsoversikt
                </div>

                <h3 className="mln">Opprinnelig avtale</h3>

                <div className="line r-mts">
                    <div className="unit size2of3">Pris for varen</div>
                    <div className="unit size1of3 rightify">
                        {formatOreToKroner(amount)}
                    </div>
                </div>
                <div className="line r-mts">
                    <div className="unit size2of3">Frakt</div>
                    <div className="unit size1of3 rightify">
                        {formatOreToKroner(freight)}
                    </div>
                </div>

                {isBuyer && (
                    <div className="line r-mts">
                        <div className="unit size2of3">Gebyr til FINN</div>
                        <div className="unit size1of3 rightify">
                            {formatOreToKroner(fee)}
                        </div>
                    </div>
                )}

                <div className="line r-mtm">
                    <div className="unit size2of3 strong">Sum</div>
                    <div className="unit size1of3 rightify strong">
                        {formatOreToKroner(sum)}
                    </div>
                </div>

                {!!discount && this.renderDiscount()}
            </div>
        );
    }

    render() {
        return (
            <div
                className="r-mal pvm"
                style={{
                    borderTop: '#DFE4E8 solid 1px',
                    borderBottom: '#DFE4E8 solid 1px',
                }}
            >
                {this.state.expanded
                    ? this.renderExpanded()
                    : this.renderCollapsed()}
            </div>
        );
    }
}

DiscountDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    discount: PropTypes.number.isRequired,
    discountFee: PropTypes.number.isRequired,
    role: PropTypes.oneOf(['BUYER', 'SELLER']).isRequired,
};

export default DiscountDetails;



// WEBPACK FOOTER //
// ./safeTrade/resolution/discountDetails.jsx